import { render, staticRenderFns } from "./DbpyES_Details.vue?vue&type=template&id=6e554455"
import script from "./DbpyES_Details.vue?vue&type=script&lang=js"
export * from "./DbpyES_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports